import { useEffect } from 'react';
import { type SoundMix, sound } from '../sound';
import { savePrefs, useGame } from '../store';

/** Sound volume, saved with the preferences and applied at once. */
export function VolumeSlider() {
  const volume = useGame((s) => s.volume);
  useEffect(() => sound.setVolume(volume), [volume]);
  return (
    <label className="volume">
      <input
        type="range"
        min={0}
        max={1}
        step={0.05}
        value={volume}
        onChange={(e) => {
          useGame.setState({ volume: Number(e.target.value) });
          savePrefs(useGame.getState());
        }}
        onPointerUp={() => sound.play('click')}
      />
      <span>{Math.round(volume * 100)}%</span>
    </label>
  );
}

/** One kind of sound's level (Settings → Sound), saved and applied at once. */
export function MixSlider({ channel, label }: { channel: keyof SoundMix; label: string }) {
  const mix = useGame((s) => s.soundMix);
  useEffect(() => sound.setMix(mix), [mix]);
  const value = mix[channel];
  return (
    <label className="volume mix">
      <span className="mix-label">{label}</span>
      <input
        type="range"
        min={0}
        max={1}
        step={0.05}
        value={value}
        onChange={(e) => {
          useGame.setState({ soundMix: { ...mix, [channel]: Number(e.target.value) } });
          savePrefs(useGame.getState());
        }}
        onPointerUp={() => sound.play('click')}
      />
      <span>{Math.round(value * 100)}%</span>
    </label>
  );
}
